import { render, staticRenderFns } from "./IFrameDailyPuzzle.vue?vue&type=template&id=4881b2aa&scoped=true&"
import script from "./IFrameDailyPuzzle.vue?vue&type=script&lang=js&"
export * from "./IFrameDailyPuzzle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881b2aa",
  null
  
)

export default component.exports